import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarRef,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { SnackbarTypeEnum } from 'src/app/data/models/enum/snackbar-type.enum';

import { CustomSnackbarComponent } from './custom-snackbar.component';


@Injectable({
  providedIn: 'root',
})
export class CustomSnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  /**
   * @deprecated
   * Substituir pelo Open()
   */
  showNotification(
    displayMessage: string,
    duration: number,
    panelClass?: string[]
  ): MatSnackBarRef<CustomSnackbarComponent> {
    return this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: {
        message: displayMessage,
      },
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: panelClass ?? ['blue-snackbar'],
    });
  }

  open(
    message: string,
    snackType: SnackbarTypeEnum,
    horizontalPosition: MatSnackBarHorizontalPosition,
    verticalPosition: MatSnackBarVerticalPosition
  ) {
    const x = this.snackBar.openFromComponent(CustomSnackbarComponent, {
      panelClass: `${snackType.toLowerCase()}-snackbar`,
      duration: 3500,
      horizontalPosition: horizontalPosition,
      verticalPosition: verticalPosition,
      data: { message: message, snackType: snackType },
    });
  }
}
